// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"TableHead_tableHeader__dXAB0"};